import { Form, InputGroup } from "react-bootstrap";
import CurrencyFormat from "react-currency-format";

const AmountInputField = ({
    symbol,
    name,
    customClass,
    placeholder,
    value,
    handleChange,
    isInvalid,
    isDisabled,
    InputGroupText
}) => {
  return (
    <InputGroup className="input-group input-box">
      <InputGroup.Text>
        <span className="rupee-symbol">{symbol || "₹"}</span>{" "}
      </InputGroup.Text>

      <CurrencyFormat
        customInput={Form.Control}
        className={`amount-input ${customClass}`}
        type="text"
        name={name}
        placeholder={placeholder || ""}
        value={value || ""}
        onValueChange={(e) => {
          handleChange(e?.value)
        }}
        isInvalid={isInvalid}
        thousandSeparator={true}
        decimalScale={2}
        fixedDecimalScale={true}
        disabled={isDisabled}
      />
      {InputGroupText}
    </InputGroup>
  );
};
export default AmountInputField;
